// src/context/TasksContext.js
import { createContext, useState, useContext, useCallback } from "react";

const TasksContext = createContext();

export const TasksProvider = ({ children }) => {
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  // هر وقت این تابع صدا زده شود، عدد زیاد می‌شود و باعث رفرش لیست‌ها می‌شود
  const refreshTasks = useCallback(() => {
    setRefreshTrigger(prev => prev + 1);
  }, []);

  return (
    <TasksContext.Provider value={{ refreshTrigger, refreshTasks }}>
      {children}
    </TasksContext.Provider>
  );
};

export const useTasks = () => useContext(TasksContext);